import type { DomApplier } from '../cssFeatures.types'

export const themeFontsAndColorsDomApplier: DomApplier<'themeFontsAndColors'> = (
	__,
	___,
	____,
	{ themeFontsAndColorsCssStyle }
) => {
	if (!themeFontsAndColorsCssStyle) {
		return {}
	}

	return themeFontsAndColorsCssStyle
}
